import AddressModelBase from '../_generated/modelBases/address-model-base';

export default class AddressModel extends AddressModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
